import { withDashboardLayout } from 'layouts/DashboardLayout/DashboardLayout';
import { Menu } from 'semantic-ui-react';
import PageContainer from 'components/PageContainer/PageContainer';
import { NavLink, Redirect, Route, Switch } from 'react-router-dom';
import React from 'react';
import TerminalIDPage from 'pages/ConfigurationPage/TerminalIDPage/TerminalIDPage';

function ConfigurationPage() {
  return (
    <PageContainer
      leftComponent={
        <>
          <h1>Configuración de la aplicación</h1>
          <Menu pointing secondary>
            <Menu.Item
              as={NavLink}
              activeClassName="active"
              to="/configuration/terminal-id"
            >
              Terminal ID
            </Menu.Item>
          </Menu>
        </>
      }
    >
      <Switch>
        <Route
          path="/configuration"
          exact
          component={() => <Redirect to="/configuration/terminal-id" />}
        />
        <Route
          exact
          path="/configuration/terminal-id"
          component={TerminalIDPage}
        />
      </Switch>
    </PageContainer>
  );
}

export default withDashboardLayout(ConfigurationPage);
